import {useNavigate} from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";

import Page from "@/components/Page";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VenueManager from "@/components/VenueManager";

import {getInternalClubId} from "@/utils/constants";

export default function VenuesPage(props) {
	const navigate = useNavigate();
	return (
		<Page>
			<Breadcrumbs
				current="Campi"
				actions={
					getInternalClubId() && (
						<MainActions
							actions={[
								{
									icon: <HomeIcon />,
									title: "Campi del mio club",
									variant: "outlined",
									onClick: () =>
										navigate("/settings/clubs/" + getInternalClubId()),
								},
							]}
						/>
					)
				}
			/>
			<VenueManager {...props} />
		</Page>
	);
}
